import { jsx as _jsx } from "react/jsx-runtime";
// src/main.tsx
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import App from "./App";
import store from "./Redux/store";
// ✅ Debug log: confirm this file is loaded in the browser
console.log("APP ENTRY LOADED: main.tsx running");
const container = document.getElementById("root");
if (!container) {
    throw new Error("Root container element not found");
}
createRoot(container).render(_jsx(Provider, { store: store, children: _jsx(BrowserRouter, { children: _jsx(App, {}) }) }));
